import types from './types';
import create from '~/misc/create';

import get from 'lodash/get';
import HTTPError from '~/misc/HTTPError';
import {promiseAction, ActionError} from '~/misc/dispatch';
import * as api from './api';
import {initUser} from '~/modules/user/actions';
import store from '~/store';

export const getHpInfo = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GET_PAYMENT_INFO,
  api.getHpInfoApi(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const getBuyerInfo = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.JUDGE_IS_BUYER_OR_NOT,
  api.getBuyerInfoApi(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const getHpPlanInfo = (dispatch, getState, val) => {
  let accountObj = getState().account;
  const {accountLevel} = getState().account;
  const objKey = (value, compare = (a, b) => a == b) => {
    return Object.keys(accountObj).find(k => compare(accountObj[k], value))
  };
  // 只给升级购买
  const options = val ? val : (accountLevel ? objKey(parseInt(accountLevel) + 1) : objKey(2));

  return promiseAction(
    dispatch,
    getState,
    types.HP_GET_PLANS_INFO,
    api.getHpPlanInfoApi(getState, options).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    })
  );
}

export const initPlanInfo = (dispatch) => dispatch(create(types.HP_PALN_MODES_INIT, {}));

export const createOrderAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.HP_CREATE_ORDER,
  api.createOrderApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const saveBsicInfo = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.HP_SAVE_BASIC_INFO,
  api.saveBsicInfoApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const payOrderAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.HP_PAY_ORDER,
  api.payOrderApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
).then(() => store.dispatch(initUser()));

export const getPaymentInfo = (dispatch, getState, orderId) => promiseAction(
  dispatch,
  getState,
  types.HP_GET_PAYMENT_INFO,
  api.getPaymentInfoApi(getState, orderId).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const hideAsyncErrorMessage = (dispatch, val) => dispatch(create(types.HP_PAGE_ASYNG_ERROR_HIDE, val));
  
export const getPaymentInfosAction = (getData) => (dispatch, getState) =>
  api.getPaymentInfosAPI(getState, getData);


// WEBPACK FOOTER //
// ./src/modules/hp/actions.js